export default __webpack_public_path__ + "static/media/documentation.e32bb3f7.png";